import React, { useEffect, useState } from 'react';
import { X, Sparkles, ArrowRight } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const WEEK = 7 * 24 * 60 * 60 * 1000;
const VIEW_THRESHOLD = 5;

export default function SignupNudge() {
  const { user, login } = useAuth();
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (user || pathname.startsWith('/admin') || pathname.startsWith('/auth')) { setShow(false); return; }
    const t = setTimeout(() => {
      if (localStorage.getItem('bzpm_user_dismissed_forever')) return;
      const snoozed = parseInt(localStorage.getItem('bzpm_nudge_snooze') || '0', 10);
      if (snoozed && Date.now() - snoozed < WEEK) return;
      const first = parseInt(localStorage.getItem('bzpm_first') || '0', 10);
      const views = parseInt(localStorage.getItem('bzpm_vc') || '0', 10);
      const weekReturning = first && Date.now() - first >= WEEK;
      if (weekReturning || views >= VIEW_THRESHOLD) setShow(true);
    }, 3500);
    return () => clearTimeout(t);
  }, [user, pathname]);

  if (user || !show) return null;

  const snooze = () => {
    localStorage.setItem('bzpm_nudge_snooze', String(Date.now()));
    setShow(false);
  };

  const join = () => {
    localStorage.setItem('bzpm_nudge_snooze', String(Date.now()));
    setShow(false);
    login();
  };

  return (
    <div
      data-testid="signup-nudge"
      className="fixed bottom-5 right-5 z-[60] w-[min(360px,calc(100vw-2.5rem))] animate-[nudgeIn_0.4s_ease-out]"
    >
      <div className="relative bg-white rounded-2xl shadow-[0_30px_70px_-30px_rgba(14,23,38,0.55)] border border-black/5 p-6 overflow-hidden">
        <div className="absolute -top-10 -right-10 w-28 h-28 rounded-full bg-[#2E6BFF]/10" />
        <button
          data-testid="nudge-dismiss-btn"
          onClick={snooze}
          className="absolute top-3 right-3 text-[#9aa3b2] hover:text-[#0E1726] transition-colors"
          aria-label="Dismiss"
        >
          <X size={18} />
        </button>
        <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wide text-[#2E6BFF]">
          <Sparkles size={13} /> You keep coming back
        </span>
        <h3 className="font-display font-extrabold text-[#0E1726] text-[20px] leading-tight mt-2.5">
          Make bytesizePM yours
        </h3>
        <p className="text-[#5B6472] text-sm leading-relaxed mt-2">
          Create a free account to join the community, react and comment on posts, and get Rajni's weekly PM digest in your inbox.
        </p>
        <button
          data-testid="nudge-signup-btn"
          onClick={join}
          className="group mt-4 w-full bg-[#2E6BFF] text-white font-semibold py-3 rounded-full inline-flex items-center justify-center gap-2 hover:bg-[#1f5aef] transition-colors"
        >
          Create free account
          <ArrowRight size={16} className="group-hover:translate-x-0.5 transition-transform" />
        </button>
        <button
          data-testid="nudge-later-btn"
          onClick={snooze}
          className="mt-2 w-full text-[#5B6472] text-sm font-medium hover:text-[#0E1726] transition-colors"
        >
          Maybe later
        </button>
      </div>
    </div>
  );
}
